import React from 'react';
import { Link } from 'react-router-dom';
import { useImages } from '../context/ImageContext';
import Footer from '../components/Footer';

const PersonalEmergencyResponseSystemPage: React.FC = () => {
  const { getImage } = useImages();

  // Images in reverse order (top image is bottom of list, etc.)
  const imageList = [
    'O-WOMAN-YELLOW-CONVERTIBLE-facebook-6-.jpg', // Top image
    'first-medical-alert-3-3-.jpg',
    'alert1-4-.jpg',
    'grandma-3-.jpg',
    'fall-detection-2.jpg',
    'Belle-in-hand-transparent-background-003--2.png',
    'all3products-Copy-21--2.jpg',
    'coverage-map-2-.jpg',
    'ul-listed-2-.jpg',
    'Candid-031.jpg',
    'TMA-Five-Diamond-Logo-2017-Copy.jpg',
    'Candid-014.jpg',
    'emsy2017resized.jpg',
    'couple-riding-bike-2-.jpg' // Bottom image
  ];

  const topImage = getImage(imageList[0]);
  const firstMedicalAlertImage = getImage(imageList[1]);
  const alert1Image = getImage(imageList[2]);
  const grandmaImage = getImage(imageList[3]);
  const fallDetectionImage = getImage(imageList[4]);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const belleImage = getImage(imageList[5]);
  const all3ProductsImage = getImage(imageList[6]);
  const coverageMapImage = getImage(imageList[7]);
  const ulListedImage = getImage(imageList[8]);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const candid031Image = getImage(imageList[9]);
  const tmaLogoImage = getImage(imageList[10]);
  const candid014Image = getImage(imageList[11]);
  const emsyImage = getImage(imageList[12]);
  const coupleRidingBikeImage = getImage(imageList[13]);

  return (
    <div className="personal-emergency-response-system-page">
      {/* Hero Section */}
      <section style={{ padding: '3rem 2rem', background: 'white' }}>
        <div className="container" style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <h1 style={{ fontSize: '2.5rem', fontWeight: 'bold', marginBottom: '2rem', color: '#c8102e' }}>
            Personal Emergency Response System: How It All Began
          </h1>
          
          <div style={{ overflow: 'hidden' }}>
            {topImage && (
              <img 
                src={topImage} 
                alt="Personal Emergency Response System" 
                style={{ 
                  float: 'right', 
                  maxWidth: '400px', 
                  width: '100%', 
                  height: 'auto', 
                  marginLeft: '2rem', 
                  marginBottom: '1rem',
                  borderRadius: '8px'
                }}
              />
            )}
            <div style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#444' }}>
              <p style={{ marginBottom: '1.5rem' }}>
                New technology makes aging in place easier than ever before. The U.S. Centers for Disease Control defines aging in place as, &ldquo;the ability to live in one&rsquo;s own home safely, independently and comfortably regardless of age or ability level.&rdquo; So, what is the key for seniors to successfully age in place? The answer is simple: a personal emergency response system.
              </p>

              <p style={{ marginBottom: '1.5rem' }}>
                Medical alerts, like those offered from <Link to="/medical-alerts" style={{ color: '#0066cc', textDecoration: 'underline' }}>Alert1</Link>, help seniors stay independent. They are a safety net that provides the opportunity to age in. If you are ever in need of help, you can instantly speak with an emergency operator at just the push of a button.
              </p>

              <p style={{ marginBottom: '1.5rem' }}>
                <Link to="/how-it-works" style={{ color: '#0066cc', textDecoration: 'underline' }}>Alert1&rsquo;s 24/7 Command Center</Link> sends you customized help and stays on the line so that you are never alone in your time of need. Your personalized emergency contact list means that we can call whomever you need. That could be your neighbor, a family member, or 911.
              </p>

              <p style={{ marginBottom: '1.5rem' }}>
                Emergency response systems come in a variety of options. Users can choose from automatic fall detection, mobile personal emergency response systems, and classic home systems. There are even fun necklaces and bracelets that coordinate with any outfit. Plus, Alert1&rsquo;s 24/7 Command Center allows users to access customized help with the use of a personalized contact list. With our personal emergency response system, you&rsquo;ll be able to call whomever you need – a neighbor, a family member, or 911.
              </p>

              <p style={{ marginBottom: '1.5rem' }}>
                Wearable technology is commonplace in the 21st century, but personal emergency response systems blazed the trail for the others. Let&rsquo;s take a look back at how far we&rsquo;ve come.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* History Section */}
      <section style={{ padding: '3rem 2rem', background: '#f9f9f9' }}>
        <div className="container" style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <h2 style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '2rem', color: '#333' }}>
            A Brief History of the First Personal Emergency Response System
          </h2>

          <div style={{ overflow: 'hidden' }}>
            {firstMedicalAlertImage && (
              <img 
                src={firstMedicalAlertImage} 
                alt="First Medical Alert System" 
                style={{ 
                  float: 'right', 
                  maxWidth: '400px', 
                  width: '100%', 
                  height: 'auto', 
                  marginLeft: '2rem', 
                  marginBottom: '1rem',
                  borderRadius: '8px'
                }}
              />
            )}
            <div style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#444' }}>
              <p style={{ marginBottom: '1.5rem' }}>
                Wilhelm Hormann invented the first personal emergency response system (PERS) in the early 1970&rsquo;s. He wanted to make sure that sick, elderly, and disabled people who lived alone would be able to call for help and cared for in any situation. But, while Hormann is credited with making the first personal emergency response system, the American International TelephoneCompany released their version to the public earlier. The fist of the personal emergency response systems included a pendant to be worn around the neck. When pressed, it sent a signal to a machine that was attached to a rotary phone. This would send a preprogrammed message to a predetermined number.
              </p>

              <p style={{ marginBottom: '1.5rem' }}>
                The single contact was the biggest drawback to the first personal emergency response systems. The contact could only get the message if they were home. And if they were home, all they knew was that the senior needed help. They did not know why they needed to be cared for.
              </p>

              <p style={{ marginBottom: '1.5rem' }}>
                Now you know how medical alerts came to be. But how did Alert1 first step foot into the aging in place industry? It all started with our founder Paul, back in 1988.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Alert1 Heritage Section */}
      <section style={{ padding: '3rem 2rem', background: 'white' }}>
        <div className="container" style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <h2 style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '2rem', color: '#333' }}>
            Alert1&rsquo;s Heritage
          </h2>

          <div style={{ overflow: 'hidden' }}>
            {alert1Image && (
              <img 
                src={alert1Image} 
                alt="Alert1 Heritage" 
                style={{ 
                  float: 'left', 
                  maxWidth: '400px', 
                  width: '100%', 
                  height: 'auto', 
                  marginRight: '2rem', 
                  marginBottom: '1rem',
                  borderRadius: '8px'
                }}
              />
            )}
            <div style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#444' }}>
              <p style={{ marginBottom: '1.5rem' }}>
                Just a few years after the first personal emergency response systems were released, Alert1 entered the picture. The company&rsquo;s founder, Paul, began to sketch out a walkie-talkie-like device that his elderly grandmother could use to contact him quickly.
              </p>

              <p style={{ marginBottom: '1.5rem' }}>
                Paul&rsquo;s grandmother was in relatively good health. &ldquo;She was as spry as can be,&rdquo; laughed Paul. &ldquo;She had never fallen. But I worried just the same that there might come a time when she would need me and I was not there.&rdquo;
              </p>

              <p style={{ marginBottom: '1.5rem' }}>
                Paul wanted his emergency response systems to be incredibly simple, but extraordinarily effective. &quot;I knew how reliable grounded phone lines were. Even when I lost power, my phone usually worked,&rdquo; he said. After weeks of determined effort, Paul revealed what is known today as the POM—Peace Of Mind—Personal Emergency Response System. With the push of a button on a medical alert bracelet, Paul&rsquo;s grandmother could contact anyone she needed: her neighbors, Paul, his parents—even 911 services. Soon enough, Paul could not make POMs quickly enough to keep up with the rising demand.
              </p>

              <p style={{ marginBottom: '1.5rem' }}>
                We are proud to help people like Paul, his parents, and their parents. Alert1 is not just another medical alert company. We help you get up on your feet again, so that you can live strong, free, and independently.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Member Testimonial Section */}
      <section style={{ padding: '3rem 2rem', background: '#f9f9f9' }}>
        <div className="container" style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <h2 style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '2rem', color: '#333' }}>
            What Our Members Have To Say About Alert1
          </h2>

          <div style={{ overflow: 'hidden' }}>
            {grandmaImage && (
              <img 
                src={grandmaImage} 
                alt="Sandy's Story" 
                style={{ 
                  float: 'right', 
                  maxWidth: '400px', 
                  width: '100%', 
                  height: 'auto', 
                  marginLeft: '2rem', 
                  marginBottom: '1rem',
                  borderRadius: '8px'
                }}
              />
            )}
            <div style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#444' }}>
              <p style={{ marginBottom: '1.5rem' }}>
                If you&rsquo;re on the fence about Alert1, we&rsquo;d like to illustrate just how helpful our services can be. Let&rsquo;s take a look at one of our long-time members, Sandy, who says that Alert1 changed her life for the better.
              </p>

              <p style={{ marginBottom: '1.5rem' }}>
                Sandy and her husband both had their Alert1 personal emergency response systems for years. Since they always went out of the house together, they felt they didn&rsquo;t need mobile alert units. But after her husband passed away in 2015, Sandy was living alone.
              </p>

              <p style={{ marginBottom: '1.5rem' }}>
                Sandy&rsquo;s children and grandchildren were able to help her out, but she couldn&rsquo;t rely on them for everything. Sandy needed something she could count on all the time. A caretaker was out of her budget. Now that she was on her own, she thought it might be time to upgrade to the newest technology available for personal emergency response systems.
              </p>

              <p style={{ marginBottom: '1.5rem' }}>
                Sandy wanted to make sure that she was safe for whatever came her way in and outside of her home. Whether it was running errands, taking a stroll in the park, or tending her garden in the yard, she wanted something with greater coverage than what her classic home unit offered. Today, Alert1 offers that mobile protection with the <Link to="/products/lifebeacon" style={{ color: '#0066cc', textDecoration: 'underline' }}>LifeBeacon</Link>.
              </p>

              <p style={{ marginBottom: '1.5rem' }}>
                <Link to="/products/lifebeacon" style={{ color: '#0066cc', textDecoration: 'underline' }}>LifeBeacon is a compact mobile medical alert</Link> that provides on-the-go protection and can include fall detection. With this technology, members can stay protected away from home and reach trained help when they need it.
              </p>

              <p style={{ marginBottom: '1.5rem' }}>
                Fast forward almost 2 years. Sandy has been aging in place independently and crossing items off of her bucket list, all while remaining safe. She has had a few slips and falls here and there, but her mobile medical alert has been there as her saving grace.
              </p>

              <p style={{ marginBottom: '1.5rem' }}>
                Sandy strongly believes that if she never got her first Alert1 unit, she wouldn&rsquo;t be living her golden years to the fullest. Sandy is another prime example of how Alert1 helps its members age in place safely, proving that age is just a number.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Today's Medical Alerts Section */}
      <section style={{ padding: '3rem 2rem', background: 'white' }}>
        <div className="container" style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <h2 style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '2rem', color: '#333' }}>
            Today&rsquo;s Medical Alerts
          </h2>

          <div style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#444', maxWidth: '900px', margin: '0 auto' }}>
            <p style={{ marginBottom: '1.5rem' }}>
              A lot has changed since the humble beginnings of the personal emergency response systems. Today&rsquo;s PERS are smaller, lighter, and have more safety features than ever before. Gone are the days of a single emergency contact. You now have a safer way to live because it&rsquo;s faster to get help.
            </p>

              <p style={{ marginBottom: '1.5rem' }}>
                When you press your help button, you are connected to <Link to="/how-it-works" style={{ color: '#0066cc', textDecoration: 'underline' }}>Alert1&rsquo;s 24/7 Command Center</Link> within seconds. A trained responder will send you help. We stay on the line with you until assistance arrives.
              </p>

            <p style={{ marginBottom: '1.5rem' }}>
              You will love the peace of mind that comes with having easy access to help at all times. A medical device will give your life the best insurance. Live in the comfort of your home without any worries about your safety.
            </p>
          </div>
        </div>
      </section>

      {/* Home Fall Detection Section */}
      <section style={{ padding: '3rem 2rem', background: '#f9f9f9' }}>
        <div className="container" style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <h2 style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '2rem', color: '#333' }}>
            Home Fall Detection
          </h2>

          <div style={{ overflow: 'hidden' }}>
            {fallDetectionImage && (
              <img 
                src={fallDetectionImage} 
                alt="Fall Detection Technology" 
                style={{ 
                  float: 'right', 
                  maxWidth: '300px', 
                  width: '100%', 
                  height: 'auto', 
                  marginLeft: '2rem', 
                  marginBottom: '1rem'
                }}
              />
            )}
            <div style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#444' }}>
              <p style={{ marginBottom: '1.5rem', fontWeight: 'bold' }}>
                Today&rsquo;s medical alerts have the added feature of fall detection. Fall detection is an innovative addition to what medical alerts already were, and changed the entire aging in place industry as we know it. So what does fall detection do? It&rsquo;s simple. It detects your fall and calls help for you.
              </p>

              <p style={{ marginBottom: '1.5rem', fontWeight: 'bold' }}>
                The <Link to="/medical-alerts" style={{ color: '#0066cc', textDecoration: 'underline' }}>fall detection pendant contains sensors within the help button</Link>. This allows the device to automatically call for help the moment it detects your fall. Now, not only can you press your help button at any time, but if you have fallen, the pendant automatically contacts the operator so that you don&rsquo;t have to.
              </p>

              <p style={{ marginBottom: '1.5rem', fontWeight: 'bold' }}>
                Even if you are unconscious, help will still be notified. Whether you can speak or not, the operator will come on the line and send help to assist you. This creates safety and peace of mind, 100% of the time.
              </p>

              <p style={{ marginBottom: '1.5rem' }}>
                Fall detection has come a long way since it was first released. At first, fall detection technology had the major drawback of false alarms. Regular movements like bumping into objects would knock the fall detection pendant and cause it to have a false alarm. In response to this, Alert1 rigorously tested pendants to detect the difference between a fall and everyday movements.
              </p>

              <p style={{ marginBottom: '1.5rem' }}>
                <Link to="/medical-alerts" style={{ color: '#0066cc', textDecoration: 'underline' }}>Alert1&rsquo;s fall detection technology</Link> has advanced. The sensor now detects falls with incredible accuracy to nearly eliminate the occurrence of false alarms. Alert1 is helping seniors...
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* What Sets Alert1 Apart Section */}
      <section style={{ padding: '3rem 2rem', background: 'white' }}>
        <div className="container" style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <h2 style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '2rem', color: '#333' }}>
            What Sets Alert1 Apart From Our Competitors?
          </h2>

          <div style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#444', maxWidth: '900px', margin: '0 auto' }}>
            <p style={{ marginBottom: '1.5rem' }}>
              While there are many medical alert companies for people to choose from, Alert1 has earned its reputation of being the #1 medical alert company in the United States. Here are our most cherished accomplishments: Our members love us, and the service we provide is unmatched.
            </p>

              <p style={{ marginBottom: '1.5rem' }}>
                At Alert1, we dedicate ourselves to serving our customers and helping them age in place. In the end, all medical alert companies have the likeminded goal to help seniors during an emergency. Our main competitors, <Link to="/pricing/compare-alert1-to-life-alert" style={{ color: '#0066cc', textDecoration: 'underline' }}>Life Alert</Link> and Phillip&rsquo;s Lifeline, also offer nationwide coverage. All three of us use Underwriters Laboratories monitoring centers and undergo random certification checks on products and services. Plus, we&rsquo;ll all stay on the line with you until help arrives.
              </p>

            <p style={{ marginBottom: '1.5rem' }}>
              All that said, there are a few additional reasons why Alert1 rises above the competition.
            </p>

            <div style={{ overflow: 'hidden' }}>
              {all3ProductsImage && (
                <img 
                  src={all3ProductsImage} 
                  alt="What Sets Alert1 Apart" 
                  style={{ 
                    float: 'right', 
                    maxWidth: '300px', 
                    width: '100%', 
                    height: 'auto', 
                    marginLeft: '2rem', 
                    marginBottom: '1rem'
                  }}
                />
              )}
              <ul style={{ marginBottom: '2rem', paddingLeft: '2rem' }}>
                <li style={{ marginBottom: '1rem' }}>
                  <strong>Alert1 is TMA 5 Diamond Certified</strong> – We are a TMA 5 Diamond Certified Center. This means the operators who help you over phone have gone through very specific training and will know exactly how to help you in any situation. We have two Command Centers, while our competitors have just one. Our Command Centers are in two different states, so we have more staff to answer quicker and get you help fast. Even in the event of a natural disaster, Alert1 can still keep its promise to members by having a backup Command Center ready to take calls.
                </li>
                <li style={{ marginBottom: '1rem' }}>
                  <strong>Alert1 Offers Better Pricing</strong> – One of the main differences Alert1 provides has to do with pricing and financing. Life Alert is significantly more expensive than Alert1. More expensive does not always mean better. While Life Alert&rsquo;s costs are higher, they lack service options that Alert1 offers to members.
                </li>
                <li style={{ marginBottom: '1rem' }}>
                  <strong>Alert1 Does Not Require Long-Term Contracts</strong> – We do not require long-term contracts of our members. On top of Life Alert&rsquo;s higher price, they require a long-term contract. When you choose Life Alert, you&rsquo;re signing for a 3-year contract with limited cancellation options. If you are unsatisfied with their system or service, you will be stuck paying unnecessary fees. By contrast, Alert1 gives our members the ability to cancel their service at any time by returning the equipment. The wellbeing of our members is our top priority, and we put that before all else.
                </li>
                <li style={{ marginBottom: '1rem' }}>
                  <strong>Multilingual Protection</strong> – We offer our members multilingual protection. Unlike Life Alert and Lifeline, our emergency responders speak over 190 different languages. This means they can assist you in whichever language you speak.
                </li>
                <li style={{ marginBottom: '1rem' }}>
                  <strong>Alert1 Offers Unlimited Button Presses Free of Charge</strong> – Nobody likes hidden fees, and Alert1 understands that. We also believe that nobody should be charged for help they receive. Because of this, every Alert1 plan comes with unlimited talk time and button presses to our members. You will never be charged for button presses, or accidental presses. Even if you just want to have a conversation with someone, you can press your button. Our operators are happy to hear from you.
                </li>
                <li style={{ marginBottom: '1rem' }}>
                  <strong>Alert1 is Looking to the Future</strong> – Alert1, a leader in personal medical alert systems, has served the needs of aging adults since 1988. The company first started with the goal of helping seniors remain independent. We have always strived to allow seniors to live without fear. With Alert1, you can be sure you are getting the latest technology to live your life safely and independently. Start living your golden years with Alert1 today!
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Certifications and Coverage Section */}
      <section style={{ padding: '3rem 2rem', background: '#f9f9f9' }}>
        <div className="container" style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <h2 style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '2rem', color: '#333' }}>
            Nationwide Coverage
          </h2>

          <div style={{ overflow: 'hidden', marginBottom: '3rem' }}>
            {coverageMapImage && (
              <img 
                src={coverageMapImage} 
                alt="Nationwide Coverage Map" 
                style={{ 
                  float: 'right', 
                  maxWidth: '300px', 
                  width: '100%', 
                  height: 'auto', 
                  marginLeft: '2rem', 
                  marginBottom: '1rem'
                }}
              />
            )}
            <div style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#444' }}>
              <p style={{ marginBottom: '1.5rem' }}>
                Alert1, Life Alert, and Lifeline all have nationwide coverage. This means that wherever you live in the United States, you will be safe and sound.
              </p>

              <p style={{ marginBottom: '1.5rem' }}>
                If you have one of Alert1&rsquo;s mobile medical alerts, you will take the nationwide safety with you while you are on the go. Bring your medical alert from the sunny shores of Florida to the sparkling waters beneath the Golden Gate Bridge. Fears for your safety will never hold you back!
              </p>
            </div>
          </div>

          <h2 style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '2rem', color: '#333', marginTop: '3rem' }}>
            UL Listed Companies
          </h2>

          <div style={{ overflow: 'hidden', marginBottom: '3rem' }}>
            {ulListedImage && (
              <img 
                src={ulListedImage} 
                alt="UL Listed Certification" 
                style={{ 
                  float: 'right', 
                  maxWidth: '250px', 
                  width: '100%', 
                  height: 'auto', 
                  marginLeft: '2rem', 
                  marginBottom: '1rem'
                }}
              />
            )}
            <div style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#444' }}>
              <p style={{ marginBottom: '1.5rem' }}>
                The next thing all three medical alert companies have in common is UL Listed monitoring centers. UL stands for Underwriters Laboratories, and they conduct safety analyses of companies.
              </p>

              <p style={{ marginBottom: '1.5rem' }}>
                Since Alert1, Life Alert, and Lifeline are all UL Listed, this means they all undergo random certification checks on products and services. Since these checks are random, you can trust that Alert1 is up to the highest standards at all times.
              </p>
            </div>
          </div>

          <h2 style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '2rem', color: '#333', marginTop: '3rem' }}>
            The Big Three Will Stay on the Line Until Help Arrives
          </h2>

          <div style={{ overflow: 'hidden' }}>
            {candid014Image && (
              <img 
                src={candid014Image} 
                alt="Call Center Operator" 
                style={{ 
                  float: 'right', 
                  maxWidth: '300px', 
                  width: '100%', 
                  height: 'auto', 
                  marginLeft: '2rem', 
                  marginBottom: '1rem'
                }}
              />
            )}
            <div style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#444' }}>
              <p style={{ marginBottom: '1.5rem' }}>
                Alert1, Life Alert, and Lifeline, all want their members to stay as safe as possible, so they all stay on the line until help arrives. This constant care is a very important aspect to members of all companies.
              </p>

              <p style={{ marginBottom: '1.5rem' }}>
                When you are in danger, the last thing you want is to be left alone. The operators can provide advice on what actions to take and help you remain calm until emergency responders get to you.
              </p>

              <p style={{ marginBottom: '1.5rem' }}>
                Even if it&rsquo;s just a false alarm, Alert1 will stay on the line until you let us know you are okay. Unlike our competitors, at Alert1 we give our members unlimited button presses. So however many false alarms you do have, you will not be penalized.
              </p>
            </div>
          </div>

          <h2 style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '2rem', color: '#333', marginTop: '3rem' }}>
            Alert1 and Life Alert are both TMA 5 Diamond Certified
          </h2>

          <div style={{ overflow: 'hidden' }}>
            {tmaLogoImage && (
              <img 
                src={tmaLogoImage} 
                alt="TMA 5 Diamond Certification" 
                style={{ 
                  float: 'right', 
                  maxWidth: '250px', 
                  width: '100%', 
                  height: 'auto', 
                  marginLeft: '2rem', 
                  marginBottom: '1rem'
                }}
              />
            )}
            <div style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#444' }}>
              <p style={{ marginBottom: '1.5rem' }}>
                Alert1 and Life Alert both share something that Lifeline doesn&rsquo;t, and this is being a TMA 5 Diamond Certified Center. This means the operators who help you over phone have gone through very specific training, and will know exactly how to help you in any situation.
              </p>

              <p style={{ marginBottom: '1.5rem' }}>
                What sets Alert1 apart from Life Alert however, is that we have two Command Centers, while they have just one. Our Command Centers are in two different states, so we have more staff to answer quicker and get you help fast. Even in the event of a natural disaster, Alert1 can still keep it&rsquo;s promise to our members by having a backup Command Center ready to take calls.
              </p>
            </div>
          </div>
        </div>
      </section>


      {/* Rating Section */}
      <section style={{ padding: '3rem 2rem', background: '#f9f9f9' }}>
        <div className="container" style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <h2 style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '2rem', color: '#333', textAlign: 'center' }}>
            Alert1 Has Been #1 Rated For 4 Years in a Row
          </h2>

          <div style={{ overflow: 'hidden' }}>
            {emsyImage && (
              <img 
                src={emsyImage} 
                alt="Alert1 Rating Award" 
                style={{ 
                  float: 'right', 
                  maxWidth: '250px', 
                  width: '100%', 
                  height: 'auto', 
                  marginLeft: '2rem', 
                  marginBottom: '1rem'
                }}
              />
            )}
            <div style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#444' }}>
              <p style={{ marginBottom: '2rem' }}>
                Alert1 stands out in one way that we are particularly proud to mention. Modern Senior Magazine* has given us the title of &ldquo;Best Medical Alarm Service&rdquo;, for four consecutive years in a row.
              </p>

              <p style={{ marginBottom: '2rem' }}>
                With all the medical alert companies out there, it is an honor to have this prestigious title and we have nobody to thank but our members. We strive to provide them the medical alert product and emergency services to age in place, and this award proves that we do just that.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Looking to the Future Section */}
      <section style={{ padding: '3rem 2rem', background: 'white' }}>
        <div className="container" style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <h2 style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '2rem', color: '#333' }}>
            Alert1 is Looking to the Future
          </h2>

          <div style={{ overflow: 'hidden' }}>
            {coupleRidingBikeImage && (
              <img 
                src={coupleRidingBikeImage} 
                alt="Alert1 Future" 
                style={{ 
                  float: 'right', 
                  maxWidth: '300px', 
                  width: '100%', 
                  height: 'auto', 
                  marginLeft: '2rem', 
                  marginBottom: '1rem'
                }}
              />
            )}
            <div style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#444' }}>
              <p style={{ marginBottom: '1.5rem' }}>
                Alert1, a medical alert system leader, has served the needs of aging adults since 1988. The company first started with the goal of helping seniors remain independent. We have always strived to allow seniors to live without fear.
              </p>

              <p style={{ marginBottom: '1.5rem' }}>
                The once small business has grown and now takes pride in having supported and cared for more than 250,000 families. Alert1 is committed to excellence and constant improvement. We provide reliable and affordable service to seniors across the United States.
              </p>

              <p style={{ marginBottom: '1.5rem' }}>
                With <Link to="/medical-alerts" style={{ color: '#0066cc', textDecoration: 'underline' }}>Alert1</Link>, you can be sure you are getting the latest technology to live your life safely and independently. Start living your golden years with Alert1 today!
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section style={{ padding: '3rem 2rem', background: '#f9f9f9' }}>
        <div className="container" style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div style={{ fontSize: '1.2rem', textAlign: 'center' }}>
            <p style={{ marginBottom: '1rem', fontWeight: 'bold' }}>
              <em>*Alert1 and Modern Senior Magazine are wholly owned and operated by ResponseLINK, LLC.</em>
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default PersonalEmergencyResponseSystemPage;
